import TimeHero from "./TimeHero";
import TimeAssignment from "./TimeAssignment";
import TimeBenefits from "./TimeBenefits";
import TimeCore from "./TimeCore";

const TimeAttendance = () => {
    return (
        <>
            <TimeHero />
            <TimeAssignment />
            <TimeBenefits />
            <TimeCore />
        </>
    );
};

export default TimeAttendance;